<div class="container" [id]="element?.id">
  <div class="row" id="topRow">
    <div class="col">
      <!-- RsSearchCard -->
      @if (element?.search?.visible) {
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">
              Search All
            </h5>
            <div class="form-group">
              <input type="text" class="form-control" [placeholder]="element?.search?.placeholder" [value]="element?.search?.value" (keyup)="filterAll($event.target.value)">
            </div>
          </div>
        </div>
      }
      <!-- RsSearchCard -->
    </div>
    <div class="col">
      <!-- RsExportCard -->
      @if (element?.export?.visible) {
        <div class="card" [ngClass]="element?.export?.theme.outerWrap">
          <div class="card-body">
            <h5 class="card-title">
              Export Options
            </h5>
            @for (exportOpt of element?.export?.options; track exportOpt) {
              <button class="btn btn-primary" [ngClass]="element?.export?.theme.btn" type="button" (click)="exportCollection(exportOpt)">
                {{ exportOpt.name }}
              </button>
            }
          </div>
        </div>
      }
      <!-- RsExportCard -->
    </div>
  </div>
  <div class="row">
    <div class="col">
      <!-- RsTableCard -->
      <div class="card overflow">
        <table class="table">
          <!-- RsTableHead -->
          <thead>
            <tr>
              @for (column of element?.columns; track column) {
                <th [class.sortable]="column.sortable" (click)="sortColumn(column)">
                  {{ column.label }}
                  @if (column.sortable && element?.sort?.active && element?.sort?.onColumn === column.property) {
                    <i class="pull-right fa"
                      [ngClass]="{'fa-chevron-down': element?.sort?.direction === 'desc', 'fa-chevron-up': element?.sort?.direction === 'asc'}">
                    </i>
                  }
                </th>
              }
            </tr>
          </thead>
          <!-- TODO: RsTableHead -->
          <tbody>
            <!-- RsFilterRow -->
            <tr>
              @for (column of element?.columns; track column) {
                <td>
                  @if (column.filterable) {
                    <input type="text" class="form-control" (keyup)="filterColumn($event.target.value, column)">
                  }
                </td>
              }
            </tr>
            <!-- RsFilterRow -->
            <!-- RsRow -->
            @for (row of currentPage; track row; let i = $index) {
              <tr>
                @for (column of element?.columns; track column) {
                  <td (click)="clickedCell(column, row, i)">
                    @if (column.type==='button') {
                      <button class="btn btn-primary" type="button">
                        {{ getCellData(row, column.property) }}
                      </button>
                    }
                    @if (column.type==='text') {
                      <input class="form-control" type="text" [value]="getCellData(row, column.property)">
                    }
                    @if (column.type==='phone') {
                      <input class="form-control" type="phone" [value]="getCellData(row, column.property)">
                    }
                    @if (column.type==='date') {
                      <input type="date" class="form-control" id="myDate" [attr.value]="getCellData(row, column.property) | date:'yyyy-MM-dd'"
                        >
                    }
                    @if (column.type==='email') {
                      <input class="form-control" type="email" [value]="getCellData(row, column.property)">
                    }
                    @if (column.type==='currency') {
                      <input class="form-control" type="currency" [value]="getCellData(row, column.property)">
                    }
                  </td>
                }
              </tr>
              @if (expandedIndex === i ) {
                <tr class="table-info">
                  <td [attr.colspan]="element?.columns.length + 1">
                    {{ row | json }}
                  </td>
                </tr>
              }
            }
            <!-- RsRow -->
          </tbody>
        </table>
      </div>
      <!-- RsTableCard -->
    </div>
  </div>
  <!-- RsTableRow -->
  <!-- RsPagination -->
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">
            Pagination
          </h5>
          <div class="row">

            <div class="col">
              <div class="btn-group">
                <button class="btn btn-primary" (click)="goToPage(0)">
                  First Page
                </button>
                <button class="btn btn-primary" (click)="goToPage(element?.pagination.page - 1)">
                  Previous Page
                </button>
              </div>
            </div>
            <div class="col rs-pagination-btns">
              @for (page of pageList; track page) {
                <button class="btn btn-primary" [class.active]="(page) === element?.pagination.page" (click)="goToPage(page)">
                  Page: {{ page + 1 }}
                </button>
              }
            </div>

            <div class="col">
              <div class="btn-group">
                <button class="btn btn-primary" (click)="goToPage(element?.pagination.page + 1)">
                  Next Page
                </button>
                <button class="btn btn-primary" (click)="goToPage(pageList.length - 1)">
                  Last Page
                </button>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label for="itemsPerPageOptions">Items Per Page</label>
                <select name="itemsPerPageOptions" id="itemsPerPageOptions" (change)="changeItemsPerPage($event.target.value)">
                  @for (opt of element?.pagination.itemsPerPageOptions; track opt) {
                    <option [value]="opt">
                      {{ opt }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- RsPagination -->
</div>
